import { BasicSearch } from './BasicSearch.component';

export { BasicSearch };
